import React from 'react';
import { testimonials } from '../data/caseStudy';
export function Testimonials() {
  return <section id="testimonials" className="w-full bg-ink text-white" aria-label="Testimonials" data-id="element-159" data-mp="3kpuhliymarik">
      <div className="mx-auto w-[1200px] px-24 py-28" data-id="element-160" data-mp="3fz5oy0b7bohu">
        <div className="h-[3px] w-28 accent-rule" aria-hidden="true" data-id="element-161" data-mp="3fxuittuaa4nk" />
        <div className="mt-16 grid grid-cols-2 gap-16" data-id="element-162" data-mp="3azt3njzzaphd">
          {testimonials.map(item => <figure key={item.attribution + item.quote.slice(0, 16)} data-id="element-163" data-mp="36zr015aonlzg">
              <blockquote className="font-display text-[30px] font-medium leading-[1.25] tracking-tight text-white" data-id="element-164" data-mp="31zd3ajej7ygq">
                <span aria-hidden="true" className="accent-text" data-id="element-165" data-mp="2x1uqghxe8z3g">
                  “
                </span>
                {item.quote}
                <span aria-hidden="true" className="accent-text" data-id="element-166" data-mp="2s3t8k0bpf5tk">
                  ”
                </span>
              </blockquote>
              <figcaption className="mt-8 font-display text-[11px] font-semibold uppercase tracking-[0.24em] text-white/50" data-id="element-167" data-mp="qall23lxthwl">
                {item.attribution}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}